import {DataItems} from '@convincely/components/src/components/Item/DataItems.js';
import {fromValue} from '@convincely/utils/lib/services/storage.js';
import {get} from '@convincely/utils/lib/object.js';

export const filterSep = /\s*(->|[<!=>]+)\s*/g;
const valueSep = /\s*,\s*/g;
const Operations = {NEQ: '!=', EQ: '=', LT: '<', GT: '>', IN: '->'};

/**
 * @param {object} inputs
 * @param {string} str
 * @param {object.<string, DataItems>} [inputMap]
 * @return {boolean}
 */
export function isOption(inputs, str, inputMap) {
  if (str.includes('|')) {
    const orStatements = str.split('||');

    if (orStatements.length > 1) {
      return orStatements.some((v) => isOption(inputs, v, inputMap));
    } else {
      return str.split('|').every((v) => isOption(inputs, v, inputMap));
    }
  } else {
    const [inputKey, operation, inputValue] = str.split(filterSep);
    const [name] = inputKey.split('.');
    const getValue = get(inputs, inputKey);

    if (!inputValue) {
      return Array.isArray(getValue) ? getValue.length > 0 : !!getValue;
    }

    let values = inputValue.split(valueSep).map(fromValue);

    if (inputValue === 'undefined') {
      values = [undefined];
    }

    switch (operation) {
      case Operations.LT:
        return values.every((v) => isNaN(getValue) && isNaN(v) ? String(getValue) < String(v) : Number(getValue) < Number(v));
      case Operations.GT:
        return values.every((v) => isNaN(getValue) && isNaN(v) ? String(getValue) > String(v) : Number(getValue) > Number(v));
      case Operations.NEQ:
        return values.every((v) => isNaN(getValue) && isNaN(v) ? String(getValue) !== String(v) : Number(getValue) !== Number(v));
      case Operations.IN:
        return values.every((v) => getValue.includes(v));
    }

    if (inputMap) {
      const item = inputMap[name];

      if (item instanceof DataItems) {
        const itemValue = get(item.map, getValue);

        if (typeof itemValue === 'object') {
          return values.includes(itemValue[item.key]);
        }

        return values.includes(itemValue);
      }

      return values.includes(get(inputMap, inputKey));
    }

    return values.includes(getValue);
  }
}

/**
 * @param {object} inputs
 * @param {DataItems} items
 * @param {string} str
 * @return {Array.<DataItem>}
 */
export function filterItems(inputs, items, str) {
  const values = str.split(valueSep).map(fromValue);

  return items.list.filter((item) => {
    if (item.exclude && isOption(inputs, item.exclude)) {
      return false;
    }

    return values.includes(item[items.key]);
  });
}
